import { default as MuiCardActionArea } from '@material-ui/core/CardActionArea';

const CardActionArea = MuiCardActionArea;

export default CardActionArea;
